import { usePcAuth } from './PcAuthProvider';

const noopAsync = async () => undefined;
const noop = () => undefined;

const usePortalAuth = () => {
  const auth = usePcAuth();
  const isLoading = typeof auth?.isLoading === 'boolean' ? auth.isLoading : !!auth?.loading;
  const getUserInfo = auth?.getUserInfo || (async () => auth?.user);

  return {
    ...auth,
    isAuthenticated: !!auth?.isAuthenticated,
    isLoading,
    loading: isLoading,
    user: auth?.user,
    loginWithRedirect: auth?.loginWithRedirect || noopAsync,
    getAccessTokenSilently: auth?.getAccessTokenSilently || noopAsync,
    getIdTokenClaims: auth?.getIdTokenClaims || noopAsync,
    getUserInfo,
    logout: auth?.logout || noop,
    getTokenWithPopup: auth?.getTokenWithPopup || auth?.getAccessTokenWithPopup || noopAsync,
    getAccessTokenWithPopup: auth?.getAccessTokenWithPopup || auth?.getTokenWithPopup || noopAsync,
  };
};

export default usePortalAuth;
